<template>
  <div class="pay-set">
    <el-row class="drink-title">
      <el-col :span="6">
        <span class="h3">{{$t('zhi_fu_she_zhi')}}</span>
      </el-col>
      <el-col :span="18" class="drink-list-filter">
        <el-form label-width="auto" :inline="true" size="mini">
          <el-col :span="8" :offset="6">
            <el-form-item :label="$t('tiao_jian_sou_suo')">
              <el-input :placeholder="$t('qing_shu_ru_zhi_fu_ming_cheng')" class="order-input-filter"
                        prefix-icon="el-icon-search" v-model="pagination.name"
                        @change="loadPaySearch"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-button size="mini" class="pay-ali" @click="handleCreateAli">
              {{$t('add_ali_pay')}}
            </el-button>
            <el-button size="mini" class="pay-wx" @click="showCreatePay('wechat')">
              {{$t('add_wx_pay')}}
            </el-button>

            <el-button size="mini" class="pay-reload" @click="loadPaySearch">
              {{$t('reload_pay')}}
            </el-button>
          </el-col>

        </el-form>
      </el-col>
    </el-row>
    <el-table :data="pays" class="pay-container">
      <el-table-column :label="$t('zhi_fu_fang_shi')" align="center">
        <template slot-scope="scope">
          <div>
            <img :src="wechatIcon" v-if="scope.row.style === 3"/>
            <img :src="alipayIcon" v-else/>
            <p class="pay-name">{{transferPayStyleName[scope.row.style] }}</p>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('zhi_fu_ming_cheng')" align="center" prop="name"></el-table-column>
      <el-table-column :label="$t('bei_zhu')" align="center">
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.style === 3" class="info">{{$t('wechat_pay_tip')}}<br/>{{$t('wechat_pay_tip_remark')}}
            </p>
            <p v-if="scope.row.style === 2" class="info">{{$t('ali_pay_tip')}}<br/>{{$t('ali_pay_tip_remark')}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('status')" align="center">
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.payType === 4  || scope.row.payType === 1" class="info">{{$t('applying')}} </p>
            <p v-if="scope.row.payType === 3" class="error">{{$t('fail')}}</p>
            <p v-if="scope.row.payType === 2  || scope.row.payType === 0" class="success">{{$t('success')}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cao_zuo')" align="center">
        <template slot-scope="scope">
          <p class="pay-operate" v-if="scope.row.payType === 2 || scope.row.payType === 0">
    <span class="user-edit"
      @click="handleRename(scope.row)">{{$t('rename_device')}}</span>
            <span class="user-edit"
                  @click="payUuid=scope.row.uuid;allocatedVisible=true;">{{$t('bang_ding_she_bei')}}</span>
            <span @click="showDevice(scope.row.uuid)">{{$t('cha_kan_she_bei')}}</span>

            <span class="pay-delete" @click="handlePayDelete(scope.row)">{{$t('shan_chu_zhi_fu')}}</span>
          </p>
          <p class="pay-operate" v-else>
            <span class="user-edit" v-if="scope.row.style!==2"
                  @click="handleApplyStatus(scope.row.style, scope.row, scope.$index)">{{$t('lookPayProgress')}}</span>
            <span class="user-edit" v-else @click="handleApplyStatus(scope.row.style, scope.row, scope.$index)">
              {{$t('queryAliStatus')}}</span>
            <span class="pay-delete" v-if="scope.row.style===2" @click="handlePayDelete(scope.row)">{{$t('shan_chu_zhi_fu')}}</span>
          </p>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>

    <slider :visible.sync="paySetVisible"
            :width="'40%'">
      <alipay :success="loadPay" :name="alipay.name" :uuid="alipay.uuid"></alipay>
    </slider>

    <c-dialog class="dialog" :visible.sync="wxApplyDialogVisible" :width="'32rem'" :height="'24rem'"
              :outer-close="false"
              :title="$t('lookPayProgress')">
      <div class="wx-apply-dialog-container">
        <div v-if="
              wxApply.applymentState === 'APPLYMENT_STATE_AUDITING' ||
              wxApply.applymentState === 'APPLYMENT_STATE_TO_BE_CONFIRMED' ||
              wxApply.applymentState === 'APPLYMENT_STATE_TO_BE_SIGNED'
            "
        >
          <qrcode :value="wxApply.signUrl" :options="{ width: 200 }"></qrcode>

          <p>{{$t('wechatScanSureAuth')}}</p>

        </div>

        <div v-if="wxApply.applymentState === 'APPLYMENT_STATE_REJECTED'">
          <p>{{$t('applyFail')}}</p>
          <p v-for="(detail, key) in wxApply.auditDetail" :key="key">{{detail.reject_reason}}</p>

        </div>
      </div>
    </c-dialog>

    <c-dialog class="dialog" :visible.sync="allocatedVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              :title="$t('fen_pei_she_bei')">

      <el-button slot="title" size="mini" type="primary" @click="deviceAllocate">{{$t('bao_cun')}}</el-button>

      <allocation-device ref="allocDevice" slot="default"></allocation-device>
    </c-dialog>

    <c-dialog class="dialog" :visible.sync="deviceVisible" :width="'50rem'" :height="'37.5rem'"
              :title="$t('yi_bang_ding_she_bei')">
      <device ref="payDevice"></device>
    </c-dialog>
  </div>
</template>

<script>
  import Slider from '@/components/Slider'
  import wechatIcon from '@/assets/img/wechat_icon.png'
  import alipayIcon from '@/assets/img/alipay_icon.png'
  import Wechat from './Wechat/create.vue'
  // import WechatUpdate from './Wechat/update.vue'
  // import Alipay from './AliPay/create.vue'
  import Alipay from './AliPay/auth.vue'
  // import AlipayUpdate from './AliPay/update.vue'
  import Device from './device'
  import {payUnion, payList, payBindDevice, payWxResourceStatus, payWxDelete, payUpdateName} from '@/api/delivery/pay/set'
  import CDialog from '@/components/Dialog'
  import AllocationDevice from '@/components/AllocateDevice'

  export default {
    name: '',
    components: {
      Slider,
      Wechat,
      Alipay,
      // WechatUpdate,
      // AlipayUpdate,
      CDialog,
      AllocationDevice,
      Device
    },
    mounted: function () {
      this.loadPay()
    },
    data: function () {
      return {
        pays: [],
        alipay: {
          uuid: '',
          name: '',
        },
        pagination: {
          start: 0,
          curPage: 1,
          limit: 8,
          total: 0,
          name: ''
        },
        wxApply: {
          applymentState: '',
          signUrl: '',
          auditDetail: []
        },
        wechatIcon,
        alipayIcon,
        paySetType: '',
        paySetVisible: false,
        allocatedVisible: false,
        deviceVisible: false,
        wxApplyDialogVisible: false,
        showInfo: '',
        payUuid: '',
        transferPayStyleName: [this.$t('wu_xiao_zhi_fu'), this.$t('wu_zhi_fu'),
          this.$t('zhi_fu_bao_zhi_fu'), this.$t('wei_xin_zhi_fu')]
      }
    },
    filters: {},
    methods: {
      showCreatePay() {
        this.$router.push({name: 'delivery.system.wxApply'})
      },
      handleApplyStatus(style, alipay, idx) {
        if (style !== 2) {
          payWxResourceStatus(alipay.uuid).then(res => {

            if (res.data.applyment_state === 'APPLYMENT_STATE_FINISHED') {
              this.pays[idx].payType = 2
              return
            }
            this.wxApply.applymentState = res.data.applyment_state
            this.wxApply.signUrl = res.data.sign_url
            this.wxApply.auditDetail = res.data.audit_detail
            this.wxApplyDialogVisible = true
          })
        } else {
          this.alipay.uuid = alipay.uuid
          this.alipay.name = alipay.name
          this.paySetVisible = true
        }
      },
      handleCreateAli() {
        this.alipay.uuid = ''
        this.alipay.name = ''
        this.paySetVisible = true
      },
      handleClickPay(pay) {
        this.paySetVisible = true
        this.paySetType = pay.type
      },
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        payList(this.pagination).then(res => {
          this.pays = res.data || []
        })
      },
      handlePayDelete(pay) {
        this.$confirm(this.$t('delete_pay_info'), this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          let vue = this
          payWxDelete(pay.uuid).then(res => {
            vue.pays.splice(vue.pays.indexOf(pay), 1)
          })


        }).catch(() => {

        })

      },

      showDevice(uuid) {
        this.deviceVisible = true
        this.$nextTick(() => {
          this.$refs.payDevice.loadDevices(uuid);
        })

      },
      loadPay() {
        let vue = this
        this.paySetVisible = false
        vue.pagination.name = ''
        payUnion(this.pagination).then(res => {
          vue.pays = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },
      loadPaySearch() {
        let vue = this
        this.pagination.curPage = 1
        this.pagination.start = 0
        payUnion(this.pagination).then(res => {
          vue.pays = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
          vue.$message.success(this.$t('loading_success'))
        })
      },
      deviceAllocate() {
        let vue = this
        let devices = vue.$refs.allocDevice.deviceAllocate()
        if (!devices.length) {
          this.$message.warning(this.$t('qing_xuan_qu_xu_yao_fen_pei_de_she_bei'))
        } else {
          payBindDevice({payUuid: vue.payUuid, devices: devices}).then(() => {
            vue.$message.success(this.$t('she_bei_bang_ding_cheng_gong'))
            vue.allocatedVisible = false
          })
        }
      },

      handleRename(info) {
        this.$prompt(this.$t('zhi_fu_ming_cheng'), this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          inputValue: info.name
        }).then(({value}) => {
          payUpdateName({uuid: info.uuid, name: value}).then(res=> {
              info.name = value
          })
        }).catch(() => {

        })
      }
    },
  }
</script>

<style lang="scss">
  .pay-set {
    padding: $padding $t-padding;

    .pay-set-title {
      height: $_header_sec_height;
      line-height: 1;
    }

    .info {
      font-size: .6rem;
    }

    .pay-ali {
      background-color: #108ee9;
      color: $f_th_color;
      border: none;
    }


    .pay-wx {
      background-color: #1AAD19;
      color: $f_th_color;
      border: none;
    }

    .pay-reload {
      background-color: $f_color;
      color: $f_th_color;
      border: none;
    }

    .wx-apply-dialog-container {
      text-align: center;

      p {
        margin-top: $padding;
      }
    }

    .pay-container {
      img {
        max-width: 2.25rem;
        width: 2.25rem;
      }

      .pay-name {
        margin-top: $padding-5;
      }

      .pay-operate {
        span {
          display: inline-block;
          margin-right: $padding-5;
          color: $f_color;
          cursor: pointer;
        }

        .pay-delete {
          color: #ffa700;
        }
      }
    }

  }
</style>
